'use strict';

var _ = require('lodash');
function OverbookingManagementGridController($scope, constants, dataService, $timeout, $q) {
  $scope.gridId = constants.GRIDS.OVERBOOKING_MANAGEMENT;
  $scope.isNotApplicableMessage = isApplicable();
  $scope.onSelectFlights = function (selectedFlights) {
    $scope.isNotApplicableMessage = !isApplicable(selectedFlights);
    if ($scope.isNotApplicableMessage) {
      $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
      return;
    }
    $timeout(function () {
      $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
    }, 150);
  };
  $scope.reloadData = function () {
    if (_.size($scope.selectedFlights) === 0) {
      return $q.when([]);
    }
    return dataService.getData($scope.selectedFlights);
  };
  $scope.onPanel = function (ev, isExpanded) {
    if (isExpanded && isApplicable($scope.selectedFlights)) {
      $timeout(function () {
        $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
      }, 150);
    }
  };
  function isApplicable(selectedFlights) {
    return _(selectedFlights).groupBy('flightId').size() === 1;
  }
}
OverbookingManagementGridController.$inject = ['$scope', 'FlightManagementConstants', 'OverbookingManagementDataService', '$timeout', '$q'];
module.exports = OverbookingManagementGridController;